import React from "react";
import { useUserContext } from "context/UserContext";
import InvoicesBK from "layouts/BK/invoices";
import InvoicesCM from "layouts/CM/invoices";
import { isBkLikeRole } from "utils/roleUtils";

function Invoices() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <InvoicesBK />;
  }
  if (role === "CM") {
    return <InvoicesCM />;
  }
  return null;
}

export default Invoices;
